/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CategoryResponse } from '../models/category-response';
import { CreateCategoryRequest } from '../models/create-category-request';
import { GenericResponse } from '../models/generic-response';
import { GetCategoriesResponse } from '../models/get-categories-response';
import { UpdateCategoryRequest } from '../models/update-category-request';

/**
 * category apis
 */
@Injectable({ providedIn: 'root' })
export class CategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllCategories()` */
  static readonly GetAllCategoriesPath = '/api/v1/categories';

  /**
   * get all categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCategories$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetCategoriesResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CategoryService.GetAllCategoriesPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetCategoriesResponse>;
        })
      );
  }

  /**
   * get all categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllCategories(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields.
       * - name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetCategoriesResponse> {
    return this.getAllCategories$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetCategoriesResponse>): GetCategoriesResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `createCategory()` */
  static readonly CreateCategoryPath = '/api/v1/categories';

  /**
   * create new category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCategory$Response(
    params: {
      body: CreateCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CategoryService.CreateCategoryPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CategoryResponse>;
        })
      );
  }

  /**
   * create new category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCategory(
    params: {
      body: CreateCategoryRequest;
    },
    context?: HttpContext
  ): Observable<CategoryResponse> {
    return this.createCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /** Path part for operation `getCategoryById()` */
  static readonly GetCategoryByIdPath = '/api/v1/categories/{id}';

  /**
   * get category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryById$Response(
    params: {
      /**
       * The category id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CategoryService.GetCategoryByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CategoryResponse>;
        })
      );
  }

  /**
   * get category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryById(
    params: {
      /**
       * The category id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<CategoryResponse> {
    return this.getCategoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }

  /** Path part for operation `disableCategoryById()` */
  static readonly DisableCategoryByIdPath = '/api/v1/categories/{id}';

  /**
   * disable category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableCategoryById$Response(
    params: {
      /**
       * The category id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CategoryService.DisableCategoryByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableCategoryById(
    params: {
      /**
       * The category id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableCategoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateCategoryById()` */
  static readonly UpdateCategoryByIdPath = '/api/v1/categories/{id}';

  /**
   * update category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCategoryById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCategoryById$Response(
    params: {
      /**
       * The category id that needs to be updated
       */
      id: number;
      body: UpdateCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      CategoryService.UpdateCategoryByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<CategoryResponse>;
        })
      );
  }

  /**
   * update category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCategoryById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCategoryById(
    params: {
      /**
       * The category id that needs to be updated
       */
      id: number;
      body: UpdateCategoryRequest;
    },
    context?: HttpContext
  ): Observable<CategoryResponse> {
    return this.updateCategoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CategoryResponse>): CategoryResponse => r.body)
    );
  }
}
